export const applyDefaultCloudSettings = (
  initialFlyoutOnboardingFormData: Record<string, any>,
  partnerId: string
) => {
  const cloudSettings = initialFlyoutOnboardingFormData.cloud_settings || {}
  if (cloudSettings.is_own_s3_bucket === undefined) {
    cloudSettings.is_own_s3_bucket = false
  }
  if (cloudSettings.stack_type === undefined) {
    cloudSettings.stack_type = 'cloudformation'
  }
  if (cloudSettings.cloud_external_id === undefined) {
    cloudSettings.cloud_external_id = partnerId
  }
  initialFlyoutOnboardingFormData.cloud_settings = cloudSettings
  return initialFlyoutOnboardingFormData
}
